import { render, staticRenderFns } from "./HistoricalNotesTree.vue?vue&type=template&id=31edb9af&scoped=true&"
import script from "./HistoricalNotesTree.vue?vue&type=script&lang=ts&"
export * from "./HistoricalNotesTree.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricalNotesTree.vue?vue&type=style&index=0&id=31edb9af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31edb9af",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VIcon,VTreeview})
